<script lang="ts">
    import { api } from "../lib/api";
    import { account, saveAccount } from "../lib/stores";
    import Button from "../lib/components/Button.svelte";
    import Card from "../lib/components/Card.svelte";
    import Input from "../lib/components/Input.svelte";
    import Label from "../lib/components/Label.svelte";

    let name = "";
    let password = "";
    let feedback = "";
    let loading = false;

    async function authorize() {
        loading = true;
        feedback = "";

        const result = await api.authorize(name, password);

        if (result.error) {
            feedback = result.error.message;
            loading = false;
        }

        if (result.data) {
            account.update((data) => {
                data.isAuthorized = true;
                data.name = name;
                data.password = password;
                return data;
            });
            saveAccount();
        }
    }
</script>

<Card>
    <div class="px-6">
        <div class="text-lg font-semibold leading-none">Вход в PIQ</div>
        <div class="text-sm text-[var(--muted-foreground)] mt-1.5">
            Введите имя и пароль администратора
        </div>
    </div>

    <form class="px-6 flex flex-col gap-4" on:submit|preventDefault={authorize}>
        <div class="flex flex-col gap-2">
            <Label forId="login-name">Имя</Label>
            <Input
                id="login-name"
                type="text"
                required
                disabled={loading}
                bind:value={name}
            />
        </div>

        <div class="flex flex-col gap-2">
            <Label forId="login-password">Пароль</Label>
            <Input
                id="login-password"
                type="password"
                required
                disabled={loading}
                bind:value={password}
            />
        </div>

        {#if feedback}
            <div
                class="text-sm rounded-lg border border-[var(--destructive)]/40 bg-[var(--destructive)]/10 text-[var(--destructive)] px-3 py-2"
            >
                {feedback}
            </div>
        {/if}

        <Button type="submit" disabled={loading} class="w-full">
            {loading ? "Вход..." : "Войти"}
        </Button>
    </form>
</Card>
